// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const peterPrinciple: Law = {
  slug: "peter-principle",
  title: "The Peter Principle",
  definition: "In a hierarchy, every employee tends to rise to his level of incompetence.",
  category: "theory",
  color: "#e579c4",
  labels: ["management"],
  copy: ["A pretty depressing and at times frustrating law, certainly if you happen to have firsthand experience.","Just read Dilbert (or watch The Office) to get some examples of this in action. \nAs for Dilbert, this one is far out my favorite!"],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
